import { render, staticRenderFns } from "./ComboboxEixo.vue?vue&type=template&id=f8686f7c"
import script from "./ComboboxEixo.vue?vue&type=script&lang=js"
export * from "./ComboboxEixo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports